import { Button } from "@material-ui/core";
import React, { useState,useEffect } from "react";
import TeacherSidebar from "../../common/Sidebar/TeacherSidebar";

// import LiveClassForm from "../TeacherLiveClass/LiveClasses";
import "./TeacherVideos.css";
import "../TeacherLiveClass/liveClasses.css";
const u = JSON.parse(localStorage.getItem('user')); 

// var videos = [
//   {
//     title: "Quantum Mechanic",
//     thumbnail: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//     description: "Difficult",
//     time: "Sat 5:30 pm, 22 Jan, 2022",
//     subject:"Physics"
//   },
//   {
//     title: "Quantum Mechanic",
//     thumbnail: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//     description: "Difficult",
//     time: "Sat 5:30 pm, 22 Jan, 2022",
//     subject: "Physics"
//   },
//   {
//     title: "Quantum Mechanic",
//     thumbnail: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//     description: "Difficult",
//     time: "Sat 5:30 pm, 22 Jan, 2022",
//     subject: "Physics"
//   },{
//     title: "Quantum Mechanic",
//     thumbnail: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//     description: "Difficult",
//     time: "Sat 5:30 pm, 22 Jan, 2022",
//     subject: "Physics"
//   },
// ]

function TeacherVideos() {
  const [allVideo, setAllVideo] = useState(true);
  // const [isLive, setLive] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  // const [data, setData] = useState("");
  const [videoData, setVideoData] = useState([]);
  useEffect(()=>{
    console.log('In use Effect');
  fetch("https://edtechv.herokuapp.com/api/get_video",{
      method: "post",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
          email: u.email,
      })
  }).then((response)=>response.json())
  .then((videos)=>{
      console.log(videos);
      setVideoData(videos);
  });
},[]);
  
  const AllVideos = () => {
    return (
      <div className="all-videos-t">
        <div className="teach-daily-videos">
          {
            videoData.map((ele)=>{ 
            return(
              <div className='daily-videos' style={{backgroundColor:"#E9F2FF",margin:"20px", padding:"15px"}}>
                <video width="400" controls="controls" preload="metadata">
                <source src={ele.thumbnail} type="video/mp4"/>
              </video>
                <div>
                    <div className='daily-videos-l'>
                    <h2>{ele.title}</h2>
                    <p>{ele.description}</p>
                    <p>{ele.subject}</p>
                    </div>
                    <div>
                        <p>{ele.time.substring(0,ele.time.indexOf("GMT"))}</p>
                    </div>
                </div>
            </div>
            )
            })
          }
        </div>
        
      </div>
    );
  };
  // const AddVideos=()=>{
  //   return (
  //     <div>
  //       <TextField/>
  //     </div>
  //   )
  // }
  return (
    <div className="educator-videos">
      <TeacherSidebar />
      <div className="teach-vid-main">
        <h1>Your Videos</h1>
        <Button
          onClick={() => setAllVideo(true)}
          style={{
            backgroundColor: `${
              allVideo ? "rgb(223, 240, 246)" : "rgb(234, 230, 230)"
            }`,
          }}
        >
          All Videos
        </Button>
        <AllVideos />
      </div>
    </div>
  );
}

export default TeacherVideos;
